import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCurrentUser } from '@/features/admin-content/use-current-user';
import { MyStudents } from '@/features/support/MyStudents';

export const Route = createFileRoute('/admin/my-students')({
  component: MyStudentsPage,
});

function MyStudentsPage() {
  const me = useCurrentUser();
  if (me.data && !me.data.staff?.studentSupport) {
    return (
      <StaffOnly
        title="Student support is off for you"
        description="Ask an admin to switch it on and give you students."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="My students"
        description="How each student is doing, and your private notes about them."
      />
      <MyStudents />
    </div>
  );
}
